import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: ""
}, "Не выбрано", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "col-12 text-center mt-3" }

import { onMounted, reactive, computed, ref } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";
type stateType = {
    id: number,
    visibleErrors: boolean,
    loader: boolean,
    password: string;
    login: string;
    roleId: number;
    position: string;
    fullName: string;
    name: string;
    email: string;
    depots: number[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'NewUserModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const { ROLE_COLLECTION } = require('@depo/constants/user');

const props = __props;

const modal = useModal(props.id);
const depotsList = ref<{ id: number, name: string }[]>([]);
const state: stateType = reactive({
    id: 0,
    visibleErrors: false,
    loader: false,
    password: '',
    login: '',
    roleId: 0,
    position: '',
    fullName: '',
    name: '',
    email: '',
    depots: [],
});
onMounted(() => {
    api.depot.get().then(r => {
        depotsList.value = r.data;
    })
});

const isLoginError = computed(() => state.login.length < 5 || !/^[a-zA-Z0-9_]+$/.test(state.login));
const isPasswordError = computed(() => state.password.length < 5 || !/^[a-zA-Z0-9]+$/.test(state.password));
const isRoleError = computed(() => !Number(state.roleId));
const isDepotsError = computed(() => !state.depots.length);

const isErrorsExist = computed(() => {
    return isLoginError.value || isPasswordError.value || isRoleError.value || isDepotsError.value;
});

function handleDepoSelect(_c: any) {
    state.depots = _c.map((i: any) => i.id);
}

function send() {
    if (isErrorsExist.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;

    api.user.create({
        login: state.login,
        roleId: state.roleId,
        password: state.password,
        position: state.position,
        fullName: state.fullName,
        name: state.name,
        email: state.email,
        depots: state.depots,
    }).then(r => {
        modal.ok(r.data);
    })
}

function ok(loco: any) {
    modal.ok({
        loco: loco,
    });
}

function close() {
    modal.cancel({
        zxc: 123,
    });
}

function cancel() {
    modal.cancel({
        zxc: 123,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-md",
    title: "Создание нового пользователя"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Логин состоит из не менее 5 букв или цифр",
              label: "Логин",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.login,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.login) = $event)),
                  "is-invalid": state.visibleErrors && isLoginError.value,
                  placeholder: "Логин"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Пароль состоит из не менее 5 букв или цифр",
              label: "Пароль",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.password) = $event)),
                  type: "password",
                  "is-invalid": state.visibleErrors && isPasswordError.value,
                  placeholder: "Пароль"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, { label: "ФИО" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.fullName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.fullName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_group_ui, { label: "Фамилия и инициалы" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите должность",
              label: "Должность"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.position,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.position) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Роль не указан",
              label: "Роль",
              required: ""
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select mt-2",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.roleId) = $event))
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ROLE_COLLECTION), (role) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: role.VALUE,
                      value: role.VALUE
                    }, _toDisplayString(role.LABEL), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, state.roleId]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Депо не указаны",
              label: "Депо"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  multiple: true,
                  "is-invalid": state.visibleErrors && isDepotsError.value,
                  options: depotsList.value,
                  placeholder: "Депо",
                  searchable: true,
                  values: state.depots,
                  onOnUpdated: handleDepoSelect
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})